import type { LaserfichePushTypeFieldSources } from "@repo/types";

export type LaserficheFieldSourceDetails = {
  label: string;
  type: "boolean" | "number" | "string" | "date";
};

const meetingFields: Record<
  LaserfichePushTypeFieldSources["agendas"],
  LaserficheFieldSourceDetails
> = {
  meetingName: { label: "Meeting Name", type: "string" },
  meetingDescription: { label: "Meeting Description", type: "string" },
  meetingTeam: { label: "Meeting Team Name", type: "string" },
  meetingType: { label: "Meeting Type", type: "string" },
  meetingTags: { label: "Meeting Tags", type: "string" },
  meetingAgendaItemTags: { label: "Meeting Agenda Item Tags", type: "string" },
  meetingAttachmentNames: {
    label: "Meeting Attached Document Names",
    type: "string",
  },
  meetingDate: { label: "Meeting Date", type: "string" },
  meetingPublishDate: { label: "Meeting Publication Date", type: "date" },
  meetingAddress: { label: "Meeting Address", type: "string" },
  meetingVersion: { label: "Meeting Revision Number", type: "number" },
  meetingCreatedAt: { label: "Meeting Creation Timestamp", type: "date" },
  meetingModifiedAt: { label: "Meeting Modification Timestamp", type: "date" },
  meetingCreatedBy: { label: "Meeting Author", type: "string" },
  meetingModifiedBy: { label: "Last User to Edit Meeting", type: "string" },
  softwareVersion: {
    label: "CiviDocs Software Label and Version",
    type: "string",
  },
};

const documentFields: Record<
  Exclude<
    LaserfichePushTypeFieldSources["documents"],
    LaserfichePushTypeFieldSources["agendas"]
  >,
  LaserficheFieldSourceDetails
> = {
  documentName: { label: "Document Name", type: "string" },
  documentDescription: { label: "Document Description", type: "string" },
  documentTeam: { label: "Document Team Name", type: "string" },
  documentTags: { label: "Document Tags", type: "string" },
  documentUrl: { label: "Document Original URL", type: "string" },
  documentFileName: { label: "Document File Name", type: "string" },
  documentFileSize: { label: "Document File Size", type: "number" },
  documentUploadType: { label: "Document Type", type: "string" },
  documentVersion: { label: "Document Save Revision", type: "number" },
  documentCreatedAt: { label: "Document Creation Time", type: "date" },
  documentModifiedAt: { label: "Document Modification Time", type: "date" },
  documentCreatedBy: { label: "Document Author", type: "string" },
  documentModifiedBy: { label: "Last User to Edit Document", type: "string" },
};

export const laserficheFieldSources: {
  [K in keyof LaserfichePushTypeFieldSources]: {
    [O in LaserfichePushTypeFieldSources[K]]: LaserficheFieldSourceDetails;
  };
} = {
  agendas: {
    ...meetingFields,
  },
  documents: {
    ...documentFields,
    ...meetingFields,
  },
  minutes: {
    ...documentFields,
    minutesOfficial: { label: "Is Official", type: "boolean" },
    minutesRevision: { label: "Revision Number", type: "number" },
    ...meetingFields,
  },
  signed: {
    ...documentFields,
    ...meetingFields,
  },
  orphanSigned: {
    ...documentFields,
  },
};
